export const ROLE_ROUTES = {
  Admin: { name: "AdminDashboardView", path: "/admin/dashboard" },
  "Sub Admin": { name: "AdminDashboardView", path: "/admin/dashboard" },
  Evaluator: { name: "EvaluatorDashboard", path: "/evaluator/dashboard" },
  Proctor: { name: "ProctorDashboard", path: "/proctor/dashboard" },
  Student: { name: "StudentDashboardView", path: "/examine" },
  "University Team": { name: "ProgramList", path: "/configuration/batch" },
  Examiner: {
    name: "EvaluatorPanelExamList",
    path: "/examiner/evaluator-panels",
  },
  // Examiner: { name: "ExaminerDashboard", path: "/examiner/dashboard" },
  "Exam Coordinator": {
    name: "ExamCoordinatorDashboard",
    path: "/exam-coordinator/dashboard",
  },
  Dsm: { name: "QuestionView", path: "/admin-question-bank" },
};

export const ACCESS_FLAG_BY_ROLE = {
  Admin: "is_admin_dashboard",
  "Sub Admin": "is_sub_admin",
  Evaluator: "is_evaluator",
  Examiner: "is_examiner",
  "Exam Coordinator": "is_exam_coordinator",
  "University Team": "is_university_team",
  Proctor: "is_proctor",
  Dsm: "is_dsm",
};

export const ROLE_PRECEDENCE = [
  "Admin",
  "Sub Admin",
  "Evaluator",
  "Examiner",
  "Exam Coordinator",
  "University Team",
  "Proctor",
  "Dsm",
  "Student",
];

export const ROLE_NAMES_WITHOUT_ACCESS_FLAG = [];

export const SWITCHABLE_ROLES = [
  ...Object.keys(ACCESS_FLAG_BY_ROLE),
  ...ROLE_NAMES_WITHOUT_ACCESS_FLAG,
];

export const ROLE_ICONS = {
  Admin: "admin_panel_settings",
  "Sub Admin": "shield_person",
  Evaluator: "fact_check",
  Examiner: "quiz",
  "Exam Coordinator": "event_available",
  "University Team": "account_balance",
  Proctor: "visibility",
  Dsm: "quiz",
};

export function iconForRole(role) {
  return ROLE_ICONS[role] || "dashboard";
}

export function deriveDashboardAccess(userData = {}) {
  const flagBased = Object.keys(ACCESS_FLAG_BY_ROLE).filter(
    (role) => !!userData[ACCESS_FLAG_BY_ROLE[role]]
  );
  const roleNames = userData.roles || [];
  const nameBased = ROLE_NAMES_WITHOUT_ACCESS_FLAG.filter((role) =>
    roleNames.includes(role)
  );
  return [...flagBased, ...nameBased];
}

export function resolveActiveRole(accessibleRoles, previousActiveRole) {
  if (previousActiveRole && accessibleRoles.includes(previousActiveRole)) {
    return previousActiveRole;
  }
  return ROLE_PRECEDENCE.find((role) => accessibleRoles.includes(role)) || null;
}

export function routeForRole(role) {
  return ROLE_ROUTES[role] || null;
}
